import { joinNoSpace } from 'Data/aggregate.js'
export function joinPhone(...values) {
  if (!values[0]) return null

  return joinNoSpace(...values)
}
